import styled, { css } from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../../../../../theme/helpers/fontStyle';

export const $DialCodePreview = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 ${spacing('sm')};
  border: 1px solid ${({ theme }) => theme.colors.default};
  margin-right: ${-spacing('px')};
  background-color: ${(props) => props.theme.systemColors.defaultBackground};
  color: ${(props) => props.theme.colors.mainTextColor};
  ${fontStyle('base')};

  ${({ $disabled }) =>
    $disabled
      ? css`
          background-color: ${({ theme }) => theme.colors.disabled};
          color: ${({ theme }) => theme.colors.disabled};
        `
      : ''}
`;
